module.exports = __webpack_public_path__ + "static/31gde-294341b553586f9dcf6f577352263191.gif";